import { useMemo } from "react";
import { useSelector } from "react-redux";

import { getYearGroup } from "seneca-common/features/class/state";
import { hasLiveSubscription } from "seneca-common/features/subscriptions/state";
import { getTeacherSubjects } from "seneca-common/features/user/state/selectors/userInfo";
import { getStudentAgeGroupFromYearGroup } from "seneca-common/utils/functions/getStudentAgeGroupFromYearGroup";
import { useSelectorOnConditionWithArgs } from "seneca-common/utils/hooks/selectors";

import { Filters } from "features/course-discovery/utils";
import { isNativeAppiOS } from "features/pwa/mobile/ios/utils/isNativeAppiOS";

export default function useGenerateCourseFilters(classId?: string): Filters {
  const userHasSubscription = useSelector(hasLiveSubscription);
  const prefilterFreeCourses = !(userHasSubscription || isNativeAppiOS());
  const yearGroup = useSelectorOnConditionWithArgs(
    classId,
    getYearGroup,
    classId
  );
  const ageGroup = yearGroup
    ? getStudentAgeGroupFromYearGroup(yearGroup)
    : undefined;

  const teacherSubjects = useSelector(getTeacherSubjects);

  const filters: Filters = useMemo(() => {
    let filters: Filters = {};
    if (prefilterFreeCourses) filters.price = "Free";
    if (ageGroup) filters["Age Group"] = ageGroup;
    if (teacherSubjects) filters.Subject = teacherSubjects;
    return filters;
  }, [ageGroup, prefilterFreeCourses, teacherSubjects]);

  return filters;
}
